import "../assets/css/vendor-product-forms.css";
import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Alert,
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Modal,
  ProgressBar,
  Spinner,
  Badge,
} from "react-bootstrap";
import DiscountFields, { discountPayloadOf } from "../components/DiscountFields";
import { useProductFormGate } from "../components/team/Gated";
import HeadOfficeProductNote from "../components/branch/HeadOfficeProductNote";
import {
  MdAddAPhoto,
  MdWarning,
  MdCrop,
  MdCropSquare,
  MdCropLandscape,
  MdDelete,
  MdAddCircle,
  MdAutoFixHigh,
  MdUndo,
} from "react-icons/md";
import { Switch, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { uploadImageToCloudinary as sharedUpload } from "../utilities/imageUpload";
import { toast } from "react-toastify";
import Select from "../components/ui/AppReactSelect";
import { AppAsyncSelect as AsyncSelect } from "../components/ui/AppReactSelect";
import CategorySuggestions from "../components/catalog/CategorySuggestions";
import { categoryPickerOptions, unitSelectOptions } from "../utilities/catalogTaxonomy";
import {
  fetchHealthcareSections,
  fetchHealthcareVendors,
} from "../actions/healthcareSectionActions";
import { createHealthcareProduct } from "../actions/healthcareProductActions";
import { getUserFromLocalStorage } from "../utilities/user.js";
import { getSiUnits } from "actions/siUnitActions";
import ReactCrop from "react-image-crop";
import { centerCrop, makeAspectCrop } from "react-image-crop";
import { IconButton, Tooltip } from "@material-ui/core";
import "react-image-crop/dist/ReactCrop.css";
import MobileProductShootPicker from "../components/MobileProductShootPicker";
import AdditionalImagesStrip from "../components/AdditionalImagesStrip";
import ProductVideoSection from "../components/ProductVideoSection";
import ArtworkTemplateLink from "../components/ArtworkTemplateLink";
import { productPhotoHint } from "../utilities/productPhotoRules";
import AppSelect from "../components/ui/AppSelect";
import { vendorOwnerIdOf } from "../utilities/vendorScope";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "normal",
    fontSize: "12px",
    textTransform: "capitalize",
  },
}));

const healthcareStyles = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.create-healthcare-card {
  animation: fadeIn 0.5s ease-out;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.create-healthcare-header {
  background: linear-gradient(135deg, #E91E63 0%, #C2185B 100%) !important;
  color: white !important;
  padding: 20px 24px !important;
  border: none !important;
  border-radius: 16px 16px 0 0 !important;
}

.create-healthcare-body {
  padding: 24px !important;
  background: white;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.form-section-healthcare {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.form-section-healthcare:hover {
  box-shadow: 0 4px 12px rgba(233, 30, 99, 0.08);
}

.form-label-healthcare {
  font-weight: 600 !important;
  color: #E91E63 !important;
  font-size: 14px !important;
  margin-bottom: 8px !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-healthcare {
  border: 2px solid #e9ecef !important;
  border-radius: 8px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-healthcare:focus {
  border-color: #E91E63 !important;
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.15) !important;
}

.btn-healthcare-primary {
  background: #E91E63 !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
  box-shadow: 0 4px 12px rgba(233, 30, 99, 0.3) !important;
}

.btn-healthcare-primary:hover {
  background: #C2185B !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(233, 30, 99, 0.4) !important;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.modal-adorned .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

.modal-adorned .modal-header {
  background: linear-gradient(135deg, #E91E63 0%, #C2185B 100%) !important;
  color: white !important;
  border-radius: 16px 16px 0 0 !important;
  padding: 24px !important;
  border: none !important;
}

.modal-adorned .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.modal-adorned .modal-title {
  font-weight: 700 !important;
  font-family: 'Inter', sans-serif !important;
  display: flex !important;
  align-items: center !important;
}
`;

const CreateHealthcareProductForm = () => {
  const user = getUserFromLocalStorage();
  const vendorId = vendorOwnerIdOf(user);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const sections = useSelector(
    (state) => state.healthcareSections.sectionsHealthcare
  );
  const healthcareVendors = useSelector(
    (state) => state.healthcareSections.healthcareVendors
  );
  const { siUnits, loading } = useSelector((state) => state.siUnits);

  const isMounted = useRef(true);
  const initialSection = location.state?.sectionId || "";

  const [product, setProduct] = useState({
    name: "",
    description: "",
    section: initialSection,
    healthcareVendor: "",
    price: 0.0,
    /* "Ask us for a price" instead of a published figure. The healthcare
       product model has carried `priceOnRequest` since 27 Sep 2026 and both
       the create and the update controller read and write it, but no
       healthcare form ever sent it, so the only way a pharmacy product could
       get the posture was a direct database write. Starts false, matching the
       schema default: a product is priced and published unless the vendor
       deliberately says otherwise. */
    priceOnRequest: false,
    productType: "PRODUCT",
    requiresPrescription: false,
    ageRestriction: 0,
    controlledSubstance: false,
    countInStock: 0,
    availableSlots: 10,
    image: null,
    /* Optional extra angles — see AdditionalImagesStrip for details. */
    additionalImages: [],
    /* Product videos — frozen contract entries, see ProductVideoSection. */
    videos: [],
    // Deactivated until QC activates it (see the model default).
    enabled: false,
    measurements: 1,
    requiredPaymentMethod: "NONE",
    discount: null,
  });

  const [priceWarning, setPriceWarning] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [inputValue, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const gate = useProductFormGate(submitting || uploading);
  const [isFormatCorrect, setIsFormatCorrect] = useState(false);
  const [isSizeCorrect, setIsSizeCorrect] = useState(false);
  const [isResolutionCorrect, setIsResolutionCorrect] = useState(false);

  // Crop state
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const [aspect, setAspect] = useState(1);
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
  });
  const [completedCrop, setCompletedCrop] = useState(null);

  // Background removal state
  const [removingBackground, setRemovingBackground] = useState(false);
  const [originalImage, setOriginalImage] = useState(null);
  const [backgroundRemoved, setBackgroundRemoved] = useState(false);

  const ASPECT_RATIO = 1;
  const MIN_DIMENSION = 1000;

  useEffect(() => {
    const isSuperAdmin = user?.result?.user_role === "SUPERUSER";
    dispatch(fetchHealthcareVendors(vendorId, isSuperAdmin));
    dispatch(getSiUnits());

    return () => {
      isMounted.current = false;
    };
  }, [dispatch, vendorId]);

  // Fetch sections using healthcareId once vendors are loaded
  useEffect(() => {
    if (healthcareVendors.length > 0) {
      const healthcareId =
        healthcareVendors[0]?.healthcareId || healthcareVendors[0]?._id;
      if (healthcareId) {
        dispatch(fetchHealthcareSections(healthcareId));
      }
    }
  }, [dispatch, healthcareVendors]);

  /* The unit picker reads `siUnits` directly through unitSelectOptions(),
     which groups by family and leaves plural duplicates out. */

  // Every category, kept for the suggestions to resolve their picks against.
  const [allCategories, setAllCategories] = useState([]);
  const loadCategory = useCallback(async (inputValue) => {
    const res = await fetch("/category/get-all");
    const categories = await res.json();
    if (Array.isArray(categories)) setAllCategories(categories);
    // Grouped, "All"/"Random"/inactive left out, aliases and keywords searchable.
    return categoryPickerOptions(Array.isArray(categories) ? categories : [], {
      input: inputValue,
      selected: selectedCategory,
    });
  }, [selectedCategory]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "price") {
      if (parseFloat(value) < 0) {
        setPriceWarning("Please enter a Price higher than 0.");
        setProduct((prev) => ({ ...prev, [name]: "" }));
        return;
      } else {
        setPriceWarning("");
      }
    }

    if (name === "countInStock" && value < 0) {
      toast.error("Stock cannot be less than 0");
      return;
    }

    if (name === "ageRestriction" && value < 0) {
      toast.error("Age restriction cannot be negative");
      return;
    }

    setProduct({ ...product, [name]: value });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setUploadError("No file was selected.");
      toast.error("No file was selected.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        if (!isMounted.current) return;

        setImagePreview(reader.result);
        setProduct((prev) => ({ ...prev, image: reader.result }));
        setShowPreviewModal(true);

        const validFormats = ["image/jpeg", "image/png"];
        const isCurrentFormatCorrect = validFormats.includes(file.type);
        const isCurrentSizeCorrect = file.size <= 10 * 1024 * 1024;
        const isCurrentResolutionCorrect =
          img.width >= 1000 && img.height >= 1000;

        setIsFormatCorrect(isCurrentFormatCorrect);
        setIsSizeCorrect(isCurrentSizeCorrect);
        setIsResolutionCorrect(isCurrentResolutionCorrect);

        if (
          !isCurrentFormatCorrect ||
          !isCurrentSizeCorrect ||
          !isCurrentResolutionCorrect
        ) {
          let errorMessage =
            "Please ensure the image meets all the requirements:";
          if (!isCurrentFormatCorrect)
            errorMessage += " Must be JPG or PNG format.";
          if (!isCurrentSizeCorrect)
            errorMessage += " Must be less than or equal to 10MB.";
          if (!isCurrentResolutionCorrect)
            errorMessage += " Must be at least 1000x1000 pixels.";
          setUploadError(errorMessage);
        } else {
          setUploadError(null);
        }
      };
      img.onerror = () => {
        if (!isMounted.current) return;
        setUploadError("There was an error processing your image.");
        setImagePreview(null);
        setShowPreviewModal(false);
        toast.error("There was an error processing your image.");
      };
      img.src = reader.result;
    };
    reader.onerror = () => {
      if (!isMounted.current) return;
      setUploadError("Failed to read the image file.");
      setImagePreview(null);
      setProduct((prev) => ({ ...prev, image: null }));
      setShowPreviewModal(false);
    };
    reader.readAsDataURL(file);
  };

  const uploadImageToCloudinary = async (imageData, assetPurpose = "product_cover") => {
    if (!imageData) {
      toast.error("No image to upload!");
      return null;
    }

    setUploading(true);

    try {
      const result = await sharedUpload(imageData, {
        skipValidation: true,
        vendorMedia: {
          vendorType: "healthcare",
          vendorId: product.healthcareVendor || vendorId,
          assetPurpose,
          entityType: "healthcareProduct",
          entityId: product._id || product.name || "new-product",
          source: "dashboard",
        },
        onProgress: (percent) => {
          if (!isMounted.current) return;
          setUploadProgress(percent);
        },
      });

      const secureUrl = result.secure_url;
      if (!isMounted.current) return null;

      setUploading(false);
      return secureUrl;
    } catch (error) {
      if (!isMounted.current) return null;

      console.error("Error uploading image:", error);
      toast.error(`Failed to upload image: ${error.message}`);
      setUploading(false);
      return null;
    }
  };

  const handleRemoveBackground = async () => {
    if (!product.image) {
      toast.error("Please upload an image first");
      return;
    }

    setRemovingBackground(true);

    try {
      if (!originalImage) {
        setOriginalImage(product.image);
      }

      const base64Response = await fetch(product.image);
      const blob = await base64Response.blob();

      const formData = new FormData();
      formData.append("image_file", blob);
      formData.append("size", "auto");

      const response = await axios.post(
        "https://api.remove.bg/v1.0/removebg",
        formData,
        {
          headers: {
            "X-Api-Key": process.env.REACT_APP_REMOVEBG_API_KEY,
          },
          responseType: "blob",
        }
      );

      const reader = new FileReader();
      reader.onloadend = () => {
        setProduct({ ...product, image: reader.result });
        setBackgroundRemoved(true);
        toast.success("Background removed successfully!");
      };
      reader.readAsDataURL(response.data);
    } catch (error) {
      console.error("Background removal error:", error);
      if (error.response?.status === 403) {
        toast.error("API key invalid. Please configure Remove.bg API key.");
      } else if (error.response?.status === 402) {
        toast.error(
          "Insufficient credits. Please check your Remove.bg account."
        );
      } else {
        toast.error("Failed to remove background. Please try again.");
      }
    } finally {
      setRemovingBackground(false);
    }
  };

  const handleRestoreOriginal = () => {
    if (originalImage) {
      setProduct({ ...product, image: originalImage });
      setBackgroundRemoved(false);
      toast.info("Original image restored");
    }
  };

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
          height: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }

  const handleImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    let initialCrop;

    if (aspect) {
      initialCrop = centerAspectCrop(width, height, aspect);
    } else {
      initialCrop = {
        unit: "%",
        x: 10,
        y: 10,
        width: 80,
        height: 80,
      };
    }

    setCrop(initialCrop);
    setCompletedCrop(initialCrop);
  };

  const handleAspectChange = (newAspect) => {
    if (newAspect !== aspect) {
      setAspect(newAspect);
      if (imgRef.current) {
        const { width, height } = imgRef.current;
        setCrop(centerAspectCrop(width, height, newAspect));
      }
    } else {
      setAspect(undefined);
    }
  };

  const isCropValid = useCallback(() => {
    if (!completedCrop?.width || !completedCrop?.height) return false;

    const pixelWidth = imgRef.current
      ? completedCrop.width * (imgRef.current.naturalWidth / 100)
      : 0;
    const pixelHeight = imgRef.current
      ? completedCrop.height * (imgRef.current.naturalHeight / 100)
      : 0;

    if (aspect) {
      return pixelWidth >= MIN_DIMENSION && pixelHeight >= MIN_DIMENSION;
    }

    const MIN_FREE_CROP = 100;
    return pixelWidth >= MIN_FREE_CROP && pixelHeight >= MIN_FREE_CROP;
  }, [completedCrop, aspect]);

  const handleSaveCrop = useCallback(async () => {
    if (!imgRef.current || !completedCrop) return;

    const canvas = document.createElement("canvas");
    const image = imgRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    const base64Image = canvas.toDataURL("image/jpeg", 1.0);

    canvas.toBlob(
      (blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }

        setProduct((prev) => ({
          ...prev,
          image: base64Image,
        }));
        setImagePreview(base64Image);
        setShowPreviewModal(false);
        setIsResolutionCorrect(true);
      },
      "image/jpeg",
      1
    );
  }, [completedCrop]);

  useEffect(() => {
    if (
      completedCrop?.width &&
      completedCrop?.height &&
      imgRef.current &&
      previewCanvasRef.current
    ) {
      const image = imgRef.current;
      const canvas = previewCanvasRef.current;
      const crop = completedCrop;

      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext("2d");

      const pixelRatio = window.devicePixelRatio;

      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;

      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = "high";

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
    }
  }, [completedCrop]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    if (!product.image) {
      toast.error("Please upload a product image");
      setSubmitting(false);
      return;
    }

    if (!product.section) {
      toast.error("Please select a section");
      setSubmitting(false);
      return;
    }

    if (!product.healthcareVendor) {
      toast.error("Please select a healthcare vendor");
      setSubmitting(false);
      return;
    }

    if (selectedCategory.length === 0) {
      toast.error("Please select at least one category");
      setSubmitting(false);
      return;
    }

    try {
      // Upload image to Cloudinary if it's a base64 string
      let uploadedImageUrl = product.image;
      if (
        uploadedImageUrl &&
        typeof uploadedImageUrl === "string" &&
        uploadedImageUrl.startsWith("data:")
      ) {
        uploadedImageUrl = await uploadImageToCloudinary(uploadedImageUrl);
        if (!uploadedImageUrl) {
          if (isMounted.current) {
            toast.error("Image upload failed, please try again.");
            setSubmitting(false);
          }
          return;
        }
      }

      /* Resolve newly-picked extra angles through Cloudinary; pass
         through any already-stored https URLs unchanged. */
      let resolvedAdditional = [];
      const picked = Array.isArray(product.additionalImages)
        ? product.additionalImages
        : [];
      for (const entry of picked) {
        if (typeof entry !== "string" || !entry) continue;
        if (entry.startsWith("data:")) {
          // eslint-disable-next-line no-await-in-loop
          const url = await uploadImageToCloudinary(entry, "product_angle");
          if (!url) {
            if (isMounted.current) {
              toast.error("One of the extra angles failed to upload.");
              setSubmitting(false);
            }
            return;
          }
          resolvedAdditional.push(url);
        } else {
          resolvedAdditional.push(entry);
        }
      }

      const productData = {
        name: product.name,
        description: product.description,
        sectionId: product.section,
        healthcareId: product.healthcareVendor,
        /* Zero, not whatever was typed before the vendor switched modes: the
           listing gate in models/shared/tradePricingFields.js lets a product
           go live on the posture alone, and a stale figure travelling with it
           is a price nobody meant to publish. Same expression the brand
           product form uses. */
        price: product.priceOnRequest ? 0 : parseFloat(product.price) || 0,
        priceOnRequest: product.priceOnRequest,
        productType: product.productType,
        requiresPrescription: product.requiresPrescription,
        ageRestriction: parseInt(product.ageRestriction) || 0,
        controlledSubstance: product.controlledSubstance,
        countInStock:
          product.productType === "PRODUCT"
            ? parseInt(product.countInStock)
            : undefined,
        availableSlots:
          product.productType === "SERVICE"
            ? parseInt(product.availableSlots)
            : undefined,
        unit_id: selectedUnit?.value || null,
        measurements: parseFloat(product.measurements) || 1,
        image: uploadedImageUrl,
        additionalImages: resolvedAdditional,
        /* Contract-shaped entries; ProductVideoSection uploads on pick, so
           these are ready to persist as-is. */
        videos: Array.isArray(product.videos) ? product.videos : [],
        enabled: product.enabled,
        requiredPaymentMethod: product.requiredPaymentMethod,
        discount: discountPayloadOf(product.discount),
        category: selectedCategory,
      };

      await dispatch(createHealthcareProduct(productData, vendorId));

      if (isMounted.current) {
        toast.success("Product/Service created successfully!");
        history.push("/admin/healthcare-menu");
      }
    } catch (error) {
      console.error("Error creating product:", error);
      if (isMounted.current) {
        toast.error("Failed to create product/service");
        setSubmitting(false);
      }
    }
  };

  return (
    <>
      <style>{healthcareStyles}</style>
      <Container fluid className="vendor-product-form">
        <Row>
          <Col md="12">
            <Card className="create-healthcare-card">
              <Card.Header className="create-healthcare-header">
                <Card.Title
                  as="h4"
                  style={{ color: "white", fontWeight: "bold" }}
                >
                  Create Healthcare Product/Service
                </Card.Title>
              </Card.Header>
              <Card.Body className="create-healthcare-body">
                <Form onSubmit={handleSubmit}>
                  <HeadOfficeProductNote gate={gate} />
                {/* Vendor team permissions. Creating a product is catalogue:edit. */}
                {!gate.canCatalogue && (
                  <Alert variant="warning" className="mb-3">
                    Your role does not allow creating products. The form is read-only.
                  </Alert>
                )}

                  <Row>
                    <Col md="6">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>
                          Product/Service Name *
                        </Form.Label>
                        <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          type="text"
                          name="name"
                          value={product.name}
                          onChange={handleInputChange}
                          placeholder="Enter product/service name"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md="6">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>
                          Type *
                        </Form.Label>
                        <AppSelect block disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          name="productType"
                          value={product.productType}
                          onChange={handleInputChange}
                        >
                          <option value="PRODUCT">Product</option>
                          <option value="SERVICE">Service</option>
                        </AppSelect>
                        <Form.Text
                          className="text-muted"
                          style={{ fontSize: "11px" }}
                        >
                          Product = physical item, Service =
                          consultation/appointment
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className={classes.label}>Customer payment requirement</Form.Label>
                    <AppSelect block disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      name="requiredPaymentMethod"
                      value={product.requiredPaymentMethod}
                      onChange={handleInputChange}
                      size="sm"
                    >
                      <option value="NONE">Any method (Cash on Delivery allowed)</option>
                      <option value="ANY_ONLINE">Pay before acceptance (any online method)</option>
                      <option value="MOMO">MTN Mobile Money only</option>
                      <option value="AIRTEL">Airtel Money only</option>
                      <option value="VISA">Card only</option>
                      <option value="ZAMTEL">Zamtel Kwacha only</option>
                    </AppSelect>
                    <Form.Text className="text-muted">
                      Prepaid orders cannot be accepted or fulfilled until Lusuku confirms payment.
                    </Form.Text>
                  </Form.Group>
                  {/* Vendor discount: the list price above stays; the sale price is derived on read. */}
                  <DiscountFields
                    disabled={gate.lockPricing}
                    title={gate.pricingTitle}
                    value={product.discount}
                    onChange={(next) => setProduct((prev) => ({ ...prev, discount: next }))}
                    listPrice={product.price}
                  />

                  <Form.Group className="mb-2">
                    <Form.Label className={classes.label}>
                      Description
                    </Form.Label>
                    <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      as="textarea"
                      rows={2}
                      name="description"
                      value={product.description}
                      onChange={handleInputChange}
                      placeholder="Enter product/service description"
                    />
                  </Form.Group>

                  {/* Pricing mode. A pharmacy sells the same carton both in bulk
                      and at retail, and for the bulk side it often will not
                      publish a figure at all. The founder decision of 27 Sep 2026
                      is full commercial parity with brands, so these are the same
                      two tiles as Publications/CreateBrandProductForm.js, rebuilt
                      on this form's own Row/Col grid instead of the brand form's
                      flex markup. Without them the vendor had no way to express
                      the posture the server has always accepted. */}
                  <Row className="mb-2">
                    {[
                      {
                        val: false,
                        label: "Fixed price",
                        icon: "fas fa-dollar-sign",
                        desc: "Publish a UGX price. Every shopper sees it and can add the item to a cart.",
                      },
                      {
                        val: true,
                        label: "Price on request",
                        icon: "fas fa-comments-dollar",
                        desc: "Hide the price. Shoppers see “Price on request” and contact the pharmacy for a price.",
                      },
                    ].map(({ val, label, icon, desc }) => {
                      const active = product.priceOnRequest === val;
                      return (
                        <Col md="6" key={String(val)} className="mb-2">
                          <div
                            title={gate.pricingTitle}
                            onClick={() =>
                              !gate.lockPricing && setProduct((prev) => ({ ...prev, priceOnRequest: val }))
                            }
                            style={{
                              border: `2px solid ${active ? "#0a578b" : "#e2e8f0"}`,
                              borderRadius: 8,
                              padding: "12px 14px",
                              cursor: "pointer",
                              background: active ? "#eff6ff" : "#fff",
                              transition: "all 0.12s",
                              userSelect: "none",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 10,
                              height: "100%",
                            }}
                          >
                            <div
                              style={{
                                width: 30,
                                height: 30,
                                borderRadius: 7,
                                flexShrink: 0,
                                background: active ? "#0a578b" : "#f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className={icon}
                                style={{
                                  fontSize: "0.8rem",
                                  color: active ? "#fff" : "#94a3b8",
                                }}
                              ></i>
                            </div>
                            <div>
                              <div
                                style={{
                                  fontWeight: 700,
                                  fontSize: "0.82rem",
                                  color: active ? "#0a578b" : "#334155",
                                }}
                              >
                                {label}
                              </div>
                              <div
                                style={{
                                  fontSize: "0.72rem",
                                  color: "#64748b",
                                  marginTop: 2,
                                }}
                              >
                                {desc}
                              </div>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>

                  <Row>
                    {/* Unmounted rather than disabled when the price is on
                        request, so the `required` attribute below cannot block a
                        submit for a field the vendor was never shown. */}
                    {!product.priceOnRequest && (
                      <Col md="4">
                        <Form.Group className="mb-2">
                          <Form.Label className={classes.label}>
                            Price (UGX) *
                          </Form.Label>
                          <Form.Control disabled={gate.lockPricing} title={gate.pricingTitle}
                            type="number"
                            name="price"
                            value={product.price}
                            onChange={handleInputChange}
                            placeholder="0"
                            min="0"
                            step="0.01"
                            required
                            size="sm"
                          />
                          {priceWarning && (
                            <Form.Text
                              className="text-danger"
                              style={{ fontSize: "11px" }}
                            >
                              {priceWarning}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    )}

                    <Col md="4">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>
                          {product.productType === "PRODUCT"
                            ? "Stock Qty"
                            : "Slots"}
                        </Form.Label>
                        <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          type="number"
                          name={
                            product.productType === "PRODUCT"
                              ? "countInStock"
                              : "availableSlots"
                          }
                          value={
                            product.productType === "PRODUCT"
                              ? product.countInStock
                              : product.availableSlots
                          }
                          onChange={handleInputChange}
                          placeholder="0"
                          min="0"
                          size="sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md="4">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>
                          Measurements
                        </Form.Label>
                        <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          type="number"
                          name="measurements"
                          value={product.measurements}
                          onChange={handleInputChange}
                          placeholder="1"
                          min="0"
                          step="0.01"
                          size="sm"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Healthcare-Specific Fields */}
                  <Card
                    className="mb-2"
                    style={{
                      backgroundColor: "#FFF3E0",
                      border: "1px solid #FFE0B2",
                      padding: "12px",
                    }}
                  >
                    <Card.Body style={{ padding: "8px" }}>
                      <h6
                        className="mb-2"
                        style={{ fontWeight: 600, color: "#E91E63" }}
                      >
                        Healthcare Regulations
                      </h6>
                      <Row>
                        <Col md="4">
                          <FormControlLabel
                            control={
                              <Switch disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                checked={product.requiresPrescription}
                                onChange={(e) =>
                                  setProduct({
                                    ...product,
                                    requiresPrescription: e.target.checked,
                                  })
                                }
                                color="primary"
                              />
                            }
                            style={{ textTransform: "capitalize" }}
                            label="Requires Prescription"
                          />
                        </Col>

                        <Col md="4">
                          <FormControlLabel
                            control={
                              <Switch disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                checked={product.controlledSubstance}
                                onChange={(e) =>
                                  setProduct({
                                    ...product,
                                    controlledSubstance: e.target.checked,
                                  })
                                }
                                color="secondary"
                              />
                            }
                            style={{ textTransform: "capitalize" }}
                            label="Controlled Substance"
                          />
                        </Col>

                        <Col md="4">
                          <Form.Group>
                            <Form.Label className={classes.label}>
                              Age Restriction
                            </Form.Label>
                            <Form.Control disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                              type="number"
                              name="ageRestriction"
                              value={product.ageRestriction}
                              onChange={handleInputChange}
                              placeholder="0 (No restriction)"
                              min="0"
                            />
                            <Form.Text className="text-muted">
                              Minimum age required (0 = no restriction)
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>

                  <Row>
                    <Col md="6">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>
                          Section *
                        </Form.Label>
                        <AppSelect block disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          name="section"
                          value={product.section}
                          onChange={handleInputChange}
                          required
                          size="sm"
                        >
                          <option value="">Select section</option>
                          {sections.map((section) => (
                            <option key={section._id} value={section._id}>
                              {section.title}
                            </option>
                          ))}
                        </AppSelect>
                      </Form.Group>
                    </Col>

                    <Col md="6">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>
                          Healthcare Provider *
                        </Form.Label>
                        <AppSelect block disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          name="healthcareVendor"
                          value={product.healthcareVendor}
                          onChange={handleInputChange}
                          required
                          size="sm"
                        >
                          <option value="">Select healthcare provider</option>
                          {healthcareVendors.map((vendor) => (
                            <option
                              key={vendor._id}
                              value={vendor.healthcareId || vendor._id}
                            >
                              {vendor.name}
                            </option>
                          ))}
                        </AppSelect>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>Unit</Form.Label>
                        <Select isDisabled={gate.lockCatalogue}
                          options={unitSelectOptions(siUnits, selectedUnit?.value)}
                          value={selectedUnit?.value ? selectedUnit : null}
                          onChange={setSelectedUnit}
                          placeholder="Select unit (optional)"
                          isClearable
                          styles={{
                            control: (base) => ({ ...base, minHeight: "38px" }),
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md="6">
                      <Form.Group className="mb-2">
                        <Form.Label className={classes.label}>
                          Category *
                        </Form.Label>
                        <AsyncSelect isDisabled={gate.lockCatalogue}
                          cacheOptions
                          defaultOptions
                          isMulti
                          value={selectedCategory}
                          getOptionLabel={(e) => e.category}
                          getOptionValue={(e) => e._id}
                          loadOptions={loadCategory}
                          onInputChange={(value) => setValue(value)}
                          onChange={(value) => setSelectedCategory(value)}
                          placeholder="Search categories"
                          styles={{
                            control: (base) => ({ ...base, minHeight: "38px" }),
                          }}
                        />
                        <CategorySuggestions
                          name={product.name}
                          unitId={selectedUnit?.value || null}
                          vendorId={product.healthcareVendor}
                          categories={allCategories}
                          selected={selectedCategory}
                          disabled={gate.lockCatalogue}
                          onAdd={(category) =>
                            setSelectedCategory((prev) => [...(prev || []), category])
                          }
                          onApplyUnit={
                            gate.lockCatalogue
                              ? undefined
                              : ({ _id, unit, measurements }) => {
                                  setSelectedUnit({ value: _id, label: unit, name: unit });
                                  setProduct((prev) => ({ ...prev, measurements }));
                                }
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Form.Label className="form-label-healthcare">
                      Product Image
                    </Form.Label>
                    <div className="d-flex">
                      <Card
                        style={{
                          width: "18rem",
                          border: "2px dashed #E91E63",
                          borderRadius: "12px",
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <Card.Body
                          className="d-flex flex-column align-items-center justify-content-center"
                          style={{ minHeight: "200px" }}
                        >
                          {product.image ? (
                            <img
                              src={product.image}
                              alt="Product"
                              style={{ maxHeight: "200px", maxWidth: "100%" }}
                            />
                          ) : (
                            <Card.Text>
                              <Button
                                as="label"
                                className="btn-healthcare-primary d-flex align-items-center justify-content-center"
                                disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                              >
                                <MdAddAPhoto size={24} className="me-2" />
                                Add Image
                                <Form.Control
                                  type="file"
                                  hidden
                                  accept=".jpg, .png, .jpeg"
                                  onChange={handleImageChange}
                                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                />
                              </Button>
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                      <div className="ms-3">
                        <Form.Text className="text-muted">
                          <p style={{ marginBottom: "0" }}>
                            <strong>File requirements: </strong>
                          </p>
                          <p style={{ fontStyle: "italic", fontSize: "11px" }}>
                            {productPhotoHint()}
                          </p>
                          {/* The artwork template for this slot, when one is configured. */}
                          <ArtworkTemplateLink slotKey="healthcare.productCover" variant="inline" />
                          <MobileProductShootPicker
                            vendorId={vendorId}
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                            onSelectImage={(imageUrl) => {
                              setProduct((prev) => ({ ...prev, image: imageUrl }));
                              setImagePreview(imageUrl);
                              setUploadError(null);
                            }}
                          />
                          <AdditionalImagesStrip
                            value={product.additionalImages}
                            onChange={(next) =>
                              setProduct((prev) => ({
                                ...prev,
                                additionalImages: next,
                              }))
                            }
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          />
                          {product.image && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Button
                                variant="link"
                                as="label"
                                style={{
                                  color: "green",
                                  textDecoration: "none",
                                  textTransform: "capitalize",
                                  fontSize: "12px",
                                }}
                                disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                              >
                                Replace Image
                                <Form.Control
                                  type="file"
                                  hidden
                                  accept=".jpg, .png, .jpeg"
                                  onChange={handleImageChange}
                                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                />
                              </Button>
                              <span
                                style={{
                                  borderLeft: "1px solid #ccc",
                                  height: "30px",
                                }}
                              ></span>
                              <Button
                                variant="link"
                                style={{
                                  color: "red",
                                  textDecoration: "none",
                                  fontSize: "12px",
                                }}
                                onClick={() =>
                                  setProduct({ ...product, image: null })
                                }
                                disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                              >
                                Remove Image
                              </Button>
                            </div>
                          )}

                          {/* Background Removal Section */}
                          {product.image && (
                            <div
                              style={{
                                marginTop: "16px",
                                paddingTop: "16px",
                                borderTop: "1px solid #e9ecef",
                              }}
                            >
                              <p
                                style={{
                                  marginBottom: "8px",
                                  fontWeight: "600",
                                  color: "#E91E63",
                                  fontSize: "13px",
                                }}
                              >
                                <MdAutoFixHigh
                                  size={16}
                                  style={{
                                    marginRight: "4px",
                                    verticalAlign: "middle",
                                  }}
                                />
                                Background Removal
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <Button
                                  className="btn-healthcare-primary"
                                  size="sm"
                                  onClick={handleRemoveBackground}
                                  disabled={removingBackground || submitting}
                                  style={{
                                    fontSize: "12px",
                                    padding: "6px 12px",
                                  }}
                                >
                                  {removingBackground ? (
                                    <>
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                        style={{ marginRight: "4px" }}
                                      />
                                      Removing...
                                    </>
                                  ) : (
                                    <>
                                      <MdAutoFixHigh
                                        size={14}
                                        style={{ marginRight: "4px" }}
                                      />
                                      Remove Background
                                    </>
                                  )}
                                </Button>

                                {backgroundRemoved && originalImage && (
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={handleRestoreOriginal}
                                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                    style={{
                                      fontSize: "12px",
                                      padding: "6px 12px",
                                    }}
                                  >
                                    <MdUndo
                                      size={14}
                                      style={{ marginRight: "4px" }}
                                    />
                                    Restore Original
                                  </Button>
                                )}
                              </div>
                              {backgroundRemoved && (
                                <Alert
                                  variant="success"
                                  style={{
                                    marginTop: "8px",
                                    fontSize: "12px",
                                    padding: "8px",
                                  }}
                                >
                                  ✓ Background removed successfully!
                                </Alert>
                              )}
                              <p
                                style={{
                                  fontSize: "11px",
                                  color: "#6c757d",
                                  marginTop: "8px",
                                  fontStyle: "italic",
                                }}
                              >
                                Powered by Remove.bg - Automatically removes
                                image backgrounds
                              </p>
                            </div>
                          )}
                        </Form.Text>
                      </div>
                    </div>
                    {uploadError && (
                      <Alert
                        variant="danger"
                        className="mt-2"
                        style={{ fontSize: "12px" }}
                      >
                        <MdWarning size={16} className="me-1" />
                        {uploadError}
                      </Alert>
                    )}
                  </Form.Group>

                  <ProductVideoSection
                    videos={product.videos || []}
                    onChange={(next) =>
                      setProduct((prev) => ({ ...prev, videos: next }))
                    }
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  />

                  <div className="mb-2">
                    <FormControlLabel
                      control={
                        <Switch disabled={gate.lockActivation} title={gate.activationTitle}
                          checked={product.enabled}
                          onChange={(e) =>
                            setProduct({
                              ...product,
                              enabled: e.target.checked,
                            })
                          }
                          color="primary"
                        />
                      }
                      label="Enable this product/service"
                    />
                    <Form.Text className="text-muted">
                      New products start deactivated so they can be checked before customers see them. Turn this on only if this one has already been checked.
                    </Form.Text>
                  </div>

                  <div className="mt-3 d-flex gap-2">
                    <Button
                      variant="secondary"
                      onClick={() => history.push("/admin/healthcare-menu")}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn-healthcare-primary"
                      type="submit"
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    >
                      {submitting ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Creating...
                        </>
                      ) : (
                        "Create Product/Service"
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Crop Modal */}
        <Modal
          show={showPreviewModal}
          onHide={() => setShowPreviewModal(false)}
          size="xl"
          className="modal-adorned"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <MdCrop size={24} className="me-2" />
              Crop & Adjust Image
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={8}>
                <div style={{ maxHeight: "500px", overflow: "auto" }}>
                  {imagePreview && (
                    <ReactCrop
                      crop={crop}
                      onChange={(c) => setCrop(c)}
                      onComplete={(c) => setCompletedCrop(c)}
                      aspect={aspect}
                    >
                      <img
                        ref={imgRef}
                        src={imagePreview}
                        alt="Crop preview"
                        style={{ maxWidth: "100%" }}
                        onLoad={handleImageLoad}
                      />
                    </ReactCrop>
                  )}
                </div>
              </Col>
              <Col md={4}>
                <Card style={{ backgroundColor: "#f8f9fa" }}>
                  <Card.Body>
                    <h6 className="mb-3" style={{ fontWeight: 600 }}>
                      Crop Tools
                    </h6>

                    <div className="mb-3">
                      <p
                        style={{
                          fontSize: "13px",
                          marginBottom: "8px",
                          fontWeight: 500,
                        }}
                      >
                        Aspect Ratio:
                      </p>
                      <div className="d-flex gap-2 flex-wrap">
                        <Tooltip title="Square 1:1">
                          <IconButton
                            size="small"
                            onClick={() => handleAspectChange(1)}
                            style={{
                              backgroundColor:
                                aspect === 1 ? "#E91E63" : "#fff",
                              color: aspect === 1 ? "#fff" : "#000",
                            }}
                          >
                            <MdCropSquare />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Landscape 16:9">
                          <IconButton
                            size="small"
                            onClick={() => handleAspectChange(16 / 9)}
                            style={{
                              backgroundColor:
                                aspect === 16 / 9 ? "#E91E63" : "#fff",
                              color: aspect === 16 / 9 ? "#fff" : "#000",
                            }}
                          >
                            <MdCropLandscape />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Free Crop">
                          <IconButton
                            size="small"
                            onClick={() => handleAspectChange(undefined)}
                            style={{
                              backgroundColor: !aspect ? "#E91E63" : "#fff",
                              color: !aspect ? "#fff" : "#000",
                            }}
                          >
                            <MdCrop />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>

                    <div className="mb-3">
                      <p
                        style={{
                          fontSize: "13px",
                          marginBottom: "8px",
                          fontWeight: 500,
                        }}
                      >
                        Preview:
                      </p>
                      <div
                        style={{
                          border: "2px solid #E91E63",
                          borderRadius: "8px",
                          overflow: "hidden",
                          backgroundColor: "#fff",
                        }}
                      >
                        {completedCrop && (
                          <canvas
                            ref={previewCanvasRef}
                            style={{
                              width: "100%",
                              height: "auto",
                              maxHeight: "200px",
                              objectFit: "contain",
                            }}
                          />
                        )}
                      </div>
                    </div>

                    {!isCropValid() && completedCrop && (
                      <Alert
                        variant="warning"
                        style={{ fontSize: "12px", padding: "8px" }}
                      >
                        <MdWarning size={16} className="me-1" />
                        {aspect
                          ? `Crop must be at least ${MIN_DIMENSION}x${MIN_DIMENSION}px`
                          : "Crop area too small"}
                      </Alert>
                    )}

                    <div className="d-flex gap-2 mt-3">
                      <Button
                        className="btn-healthcare-primary"
                        onClick={handleSaveCrop}
                        disabled={!isCropValid()}
                        style={{ flex: 1 }}
                      >
                        Save Crop
                      </Button>
                      <Button
                        variant="secondary"
                        onClick={() => setShowPreviewModal(false)}
                        style={{ flex: 1 }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default CreateHealthcareProductForm;
